/**
 * A DRAFT => A FINALIZED
 * A FINALIZED => A CANCELED + B CREDITED
 */
export var InvoiceType;
(function (InvoiceType) {
    // @deprecated
    InvoiceType["DRAFT"] = "draft";
    InvoiceType["FINALIZING"] = "finalizing";
    InvoiceType["FINALIZED"] = "finalized";
    InvoiceType["CANCELED"] = "canceled";
    InvoiceType["CREDITING"] = "crediting";
    InvoiceType["CREDITED"] = "credited";
})(InvoiceType || (InvoiceType = {}));
//# sourceMappingURL=InvoiceType.js.map